(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/numbergames/dialogs/payment-success.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/numbergames/dialogs/payment-success.js');

'use strict';

class PaymentSuccess extends svs.tur.payment.dialogs.PaymentSuccess {
  getMessage() {
    const message = super.getMessage();
    if (this.andraChansen) {
      const text = this.getAndraChansenMessage({
        andraChansen: this.andraChansen
      });
      message.push({
        type: svs.components.dialog.message.TEXT,
        align: svs.components.dialog.message.align.CENTER,
        text
      });
    }
    return message;
  }
  getAndraChansenMessage(_ref) {
    let {
      andraChansen
    } = _ref;
    const isSyndicate = this.isSyndicate;
    const getChancesString = chancesObj => "".concat(chancesObj.chances, " ").concat(chancesObj.chances === 1 ? 'ny chans' : 'nya chanser');
    const extraSuccessMessage = "<b>".concat(isSyndicate ? 'Ni' : 'Du', " \xE4r med i Andra Chansen!</b><br />\n        ").concat(isSyndicate ? 'Ni' : 'Du', " fick <b>").concat(getChancesString(andraChansen), "</b> att vinna p\xE5 Andra Chansen\n        - extradragningen som ger ").concat(isSyndicate ? 'er' : 'dig', " chans till 1 miljon kr.");
    return extraSuccessMessage;
  }
}
svs.tur.payment.api.jupiter.numbergames.dialogs.PaymentSuccess = PaymentSuccess;

 })(window);